export default "__VITE_ASSET__CNZqZT1X__"